import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AOS from "aos";
import "aos/dist/aos.css";

export const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out",
      once: false,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Blogs | Lone Wolf Writes</title>
        <meta name="description" content="Lone Wolf Writes Blogs" />
        <link rel="canonical" href="https://lonewolfwrites.com/about" />
      </Helmet>
      <main>
      <div className="container mt-5" data-aos="fade-up" data-aos-delay="500" >
        <div className="row mb-2">
          <h1>About Us - Lone Wolf Writes</h1>
          <div className="col-12 col-md-4">
            <div className="card" style={{ border: 'none' }}>
              <picture>
                <img className="mb-4" src="/lone-wolf-writes-logo.png" alt=" logo | Lone Wolf writes " style={{ borderRadius: '50%', width: '100%', height: '400px', objectFit: 'cover' }} />
              </picture>
              <p>Lone Wolf Writes celebrates creativity through blogs, poems, and quotes, connecting readers emotionally and inspiring growth.</p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="card" style={{ border: 'none' }}>
              <picture>
                <img className="mb-4" src="/media/blogs/how-to-craft-quotes-that-speak-volumes.jpg" alt=" About Us | Lone Wolf writes " style={{ borderRadius: '50%', width: '100%', height: '400px', objectFit: 'cover' }} />
              </picture>
              <p>Our platform captures life’s complexities through engaging blogs, heartfelt poetry, and motivational quotes, offering relatable and profound insights.</p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="card" style={{ border: 'none' }}>
              <picture>
                <img className="mb-4" src="/media/blogs/famous-poets-and-the-stories-behind-their-masterpieces.jpg" alt=" About | Lone Wolf writes " style={{ borderRadius: '50%', width: '100%', height: '400px', objectFit: 'cover' }} />
              </picture>
              <p>Bite-sized pieces of wisdom and inspiration, thoughtfully crafted to motivate, uplift, and resonate with readers in moments of need. </p>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
        </div>
        <div className="row mt-2 mb-3">
          <p>Welcome to Lone Wolf Writes, a vibrant space where the power of words takes center stage, and creativity knows no bounds. We are a platform that celebrates the beauty of language, offering a diverse collection of blogs, poems, and quotes crafted in both Marathi and English. Through our work, we aim to connect with readers on an emotional level, inspiring them to explore, reflect, and grow through the magic of storytelling and poetic expression.</p>
          <p>Our blogs are a rich tapestry of thoughts and ideas, delving into personal journeys, societal issues, and the myriad complexities of life. From reflective pieces that spark introspection to narratives that transport you to different worlds, each blog is designed to engage, inform, and leave a lasting impression.</p>
          <p>Our poetry is where words find rhythm and emotion finds its voice. Whether it’s the evocative depth of Marathi kavita or the lyrical beauty of English verses, our poems capture the universal human experience—love, loss, hope, and resilience—through a lens that is deeply personal yet profoundly relatable.</p>
          <p>Our quotes are bite-sized pieces of wisdom and inspiration, thoughtfully crafted to motivate, uplift, and resonate with readers in moments of need. These succinct yet powerful expressions encapsulate the essence of life’s lessons, offering clarity and encouragement in the simplest of forms.</p>
          <p>The name Lone Wolf Writes is a reflection of our identity and philosophy. Like the lone wolf, we embrace the strength found in solitude and the courage to carve our own path. We believe that individuality is the heart of creativity, and through our work, we seek to explore and celebrate the unique perspectives that make each of us who we are. At the same time, we recognize the power of community, inviting readers and writers alike to share in this journey of storytelling, self-discovery, and collective growth.</p>
          <p>More than just a platform, Lone Wolf Writes is a sanctuary for dreamers, thinkers, and creators—a place where words are not just written but felt. Whether you’re seeking inspiration through heartfelt poetry, wisdom through thoughtful quotes, or a new perspective through engaging blogs, our mission is to provide a meaningful experience that lingers long after the last word is read.</p>
          <p>Join us as we continue to explore the boundless horizons of creativity and self-expression, one word at a time. At Lone Wolf Writes, every voice matters, every story counts, and every word has the power to transform.</p>
        </div>
        <hr />
      </div>
      </main>
    </>
  );
};
